import React from 'react'
import { Link, NavLink } from "react-router-dom";

const Sidebar = () => {
  return (
    <aside className="relative bg-sidebar w-64 hidden sm:block shadow-xl">
        <div className="p-6">
            <NavLink exact to="/" className="text-white text-3xl font-semibold uppercase hover:text-gray-300">Admin</NavLink>
        </div>

        <nav className="text-white text-base font-semibold pt-3">

              <div className="p-6">
                  <Link exact to="/">
                      <button className="w-full bg-white cta-btn font-semibold py-2 mt-5 rounded-br-lg rounded-bl-lg rounded-tr-lg shadow-lg hover:shadow-xl hover:bg-gray-300 flex items-center justify-center">
                          <i className="fas fa-plus mr-3"></i> Dashboard
                      </button>
                  </Link>

              </div>  

              <NavLink exact to="/subscriptions" className="flex items-center  py-4 pl-6 nav-item">
                  <i className="fas fa-table mr-3"></i>
                  Subscriptions
              </NavLink>

              <NavLink exact to="/products" className="flex items-center  py-4 pl-6 nav-item">
                  <i className="fas fa-table mr-3"></i>
                  Products
              </NavLink>

              <NavLink exact to="/vehicles" className="flex items-center  py-4 pl-6 nav-item">
                  <i className="fas fa-table mr-3"></i>
                  Vehicles
              </NavLink>

              <NavLink exact to="/batches" className="flex items-center  py-4 pl-6 nav-item">
                  <i className="fas fa-table mr-3"></i>
                  Batches
              </NavLink>

              <NavLink exact to="/orders" className="flex items-center  py-4 pl-6 nav-item">
                  <i className="fas fa-table mr-3 "></i>
                  Orders
              </NavLink>

              <NavLink exact to="/orders/update" className="flex items-center  py-4 pl-6 nav-item">
                  <i className="fas fa-table mr-3 "></i>
                  Update Orders
              </NavLink> 
           
        </nav>

     
    </aside>


      

  )
}

export default Sidebar
